import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from 'src/api';
import {
  GetBillingParams,
  GetHeadsetBillingResponse,
  GetPackageBillingResponse,
} from './companyBilling.types';

const headsetBillingApiPath = (id: string) => `companies/${id}/billing/devices`;

export const getHeadsetsBilling = async ({
  companyId,
  params,
}: {
  companyId: string;
  params?: GetBillingParams;
}): Promise<AxiosResponse<GetHeadsetBillingResponse & ApiError>> => {
  return instance
    .get<GetHeadsetBillingResponse>(headsetBillingApiPath(companyId), {
      params,
    })
    .catch((e) => e.response as AxiosError<ApiError> as never);
};

const packagesBillingApiPath = (id: string) =>
  `companies/${id}/billing/packages`;

export const getPackagesBilling = async ({
  companyId,
  params,
}: {
  companyId: string;
  params?: GetBillingParams;
}): Promise<AxiosResponse<GetPackageBillingResponse & ApiError>> => {
  return instance
    .get<GetPackageBillingResponse>(packagesBillingApiPath(companyId), {
      params,
    })
    .catch((e) => e.response as AxiosError<ApiError> as never);
};
